// import Banner from "./components/Banner";
// import General from "./components/General";
// import Notification from "./components/Notification";
// import Project from "./components/Project";
// import Storage from "./components/Storage";
// import Upload from "./components/Upload";

// const ProfileOverview = () => {
//   return (
//     <div className="flex w-full flex-col gap-5">
//       <div className="w-ful mt-3 flex h-fit flex-col gap-5 lg:grid lg:grid-cols-12">
//         <div className="col-span-4 lg:!mb-0">
//           <Banner />
//         </div>

//         <div className="col-span-3 lg:!mb-0">
//           <Storage />
//         </div>

//         <div className="z-0 col-span-5 lg:!mb-0">
//           <Upload />
//         </div>
//       </div>
//       {/* all project & ... */}

//       <div className="grid h-full grid-cols-1 gap-5 lg:!grid-cols-12">
//         <div className="col-span-5 lg:col-span-6 lg:mb-0 3xl:col-span-4">
//           <Project />
//         </div>
//         <div className="col-span-5 lg:col-span-6 lg:mb-0 3xl:col-span-5">
//           <General />
//         </div>

//         <div className="col-span-5 lg:col-span-12 lg:mb-0 3xl:!col-span-3">
//           <Notification />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfileOverview;

import React, { useState, useEffect } from "react";
import Modal from "components/common/Modal";
import CustomButton from "components/CustomButton";
import { InputField } from "components/FormFields";
import Alert from "components/common/Alert";

export default function ProfileOverview() {
  // User Profile State
  const [user, setUser] = useState({
    userId: "",
    fullName: "",
    email: "admin@gmail.com",
    phone: "",
    role: "admin",
  });

  const [alert, setAlert] = useState({ type: "", message: "" });

  // Modal Visibility States
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  // Form Input States
  const [editFormData, setEditFormData] = useState({ ...user });
  const [passwordFormData, setPasswordFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  // Load user info from localStorage on mount
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    if (userData.email || userData.role) {
      const userRole = userData.role || "admin";
      
      const computedName =
        userRole === "admin"
          ? userData.name || userData.fullName || "Administrator"
          : userRole === "exhibitor"
          ? userData.parentData?.manager_name || userData.fullName || ""
          : userData.parentData?.adminName || userData.fullName || "";

      const computedPhone =
        userRole === "admin"
          ? userData.phone || ""
          : userRole === "exhibitor"
          ? userData.parentData?.phone_number || userData.phone || ""
          : userData.parentData?.adminMobile || userData.phone || "";

      const currentUserId = userData.userId || userData._id || userData.id || "";

      const loadedUser = {
        userId: currentUserId,
        fullName: computedName,
        email: userData.email || "",
        phone: computedPhone,
        role: userRole,
      };

      setUser(loadedUser);
      setEditFormData(loadedUser);
    }
  }, []);

  // Compute Avatar Initials
  const getInitials = (name) => {
    if (!name) return "U";
    const parts = name.trim().split(" ");
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  };

  // Handle Edit Profile Form Submission
  const handleSaveProfile = (e) => {
    e.preventDefault();
    setUser({ ...editFormData });

    // Sync updated data back to localStorage if needed
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    localStorage.setItem(
      "userData",
      JSON.stringify({
        ...userData,
        email: editFormData.email,
        fullName: editFormData.fullName,
        phone: editFormData.phone,
      })
    );

    setIsEditModalOpen(false);
    setAlert({
      type: "success",
      message: "Profile information updated successfully!",
    });
  };

  // Handle Change Password Form Submission (No current password required)
  const handleChangePassword = (e) => {
    e.preventDefault();
    if (passwordFormData.newPassword !== passwordFormData.confirmPassword) {
      setAlert({
        type: "error",
        message: "New password and confirm password do not match!",
      });
      return;
    }

    if (passwordFormData.newPassword.length < 6) {
      setAlert({
        type: "error",
        message: "Password must be at least 6 characters long.",
      });
      return;
    }

    setIsPasswordModalOpen(false);
    setPasswordFormData({
      newPassword: "",
      confirmPassword: "",
    });
    setAlert({
      type: "success",
      message: "Password updated successfully!",
    });
  };

  const isAdmin = user.role === "admin";
  console.log("isAdmin",isAdmin)


  return (
    <div className="w-full p-3 font-['Poppins',sans-serif] sm:p-6">
      {/* Alert Notification */}
      {alert.message && (
        <div className="mx-auto mb-4 max-w-5xl">
          <Alert
            type={alert.type || "success"}
            message={alert.message}
            onClose={() => setAlert({ type: "", message: "" })}
          />
        </div>
      )}

      {/* Main Profile Card Container */}
      <div className="mx-auto rounded-[8px] border border-gray-100 bg-white p-5 shadow-sm sm:p-8">
        {/* Header Avatar & Details */}
        <div className="flex flex-col items-center gap-4 text-center sm:flex-row sm:items-center sm:gap-5 sm:text-left">
          <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full bg-[#EBF2FA] text-2xl font-bold text-[#4B739B]">
            {getInitials(user.fullName || user.role)}
          </div>
          <div className="flex flex-col items-center gap-1 sm:items-start">
            <h2 className="text-xl font-bold text-gray-900 sm:text-2xl">
              {!isAdmin && user.fullName ? user.fullName : user.email}
            </h2>
            <div>
              <span className="inline-block rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold capitalize text-emerald-600">
                {user.role}
              </span>
            </div>
          </div>
        </div>

        <hr className="my-6 border-gray-100 sm:my-8" />

        {/* Account Information Details Grid */}
        <div>
          <h3 className="mb-4 text-sm font-bold text-gray-800 sm:mb-6 sm:text-base">
            Account Information
          </h3>

          <div className="grid grid-cols-1 gap-y-5 sm:grid-cols-2 sm:gap-y-6">
            {/* Show Full Name only if NOT Admin */}
            {!isAdmin && (
              <div>
                <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400 sm:text-xs">
                  FULL NAME
                </p>
                <p className="mt-1 text-sm font-medium text-gray-800 sm:text-base">
                  {user.fullName || "N/A"}
                </p>
              </div>
            )}

            <div>
              <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400 sm:text-xs">
                EMAIL ADDRESS
              </p>
              <p className="mt-1 text-sm font-medium text-gray-800 sm:text-base">
                {user.email || "N/A"}
              </p>
            </div>

            {/* Show Phone Number only if NOT Admin */}
            {!isAdmin && (
              <div>
                <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400 sm:text-xs">
                  PHONE NUMBER
                </p>
                <p className="mt-1 text-sm font-medium text-gray-800 sm:text-base">
                  {user.phone || "N/A"}
                </p>
              </div>
            )}

            <div>
              <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400 sm:text-xs">
                ASSIGNED ROLE
              </p>
              <p className="mt-1 text-sm font-medium capitalize text-gray-800 sm:text-base">
                {user.role}
              </p>
            </div>
          </div>
        </div>

        <hr className="my-6 border-gray-100 sm:my-8" />

        {/* Action Buttons */}
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <CustomButton
            label="Edit Profile"
            variant="solid"
            color="#02a9e0"
            onClick={() => {
              setEditFormData({ ...user });
              setIsEditModalOpen(true);
            }}
          />

          <CustomButton
            label="Change Password"
            variant="outline"
            color="#02a9e0"
            borderColor="#02a9e0"
            onClick={() => setIsPasswordModalOpen(true)}
          />
        </div>
      </div>

      {/* ==================================================================== */}
      {/* 1. EDIT PROFILE MODAL */}
      {/* ==================================================================== */}
      <Modal
        open={isEditModalOpen}
        title="Edit Profile"
        onClose={() => setIsEditModalOpen(false)}
      >
        <form onSubmit={handleSaveProfile} className="flex flex-col gap-4 py-2">
          {/* Show Full Name Input if NOT Admin */}
          {!isAdmin && (
            <InputField
              label="Full Name"
              name="fullName"
              value={editFormData.fullName}
              onChange={(e) =>
                setEditFormData({ ...editFormData, fullName: e.target.value })
              }
              placeholder="Enter full name..."
            />
          )}

          <InputField
            label="Email Address"
            name="email"
            type="email"
            value={editFormData.email}
            onChange={(e) =>
              setEditFormData({ ...editFormData, email: e.target.value })
            }
            placeholder="Enter email address..."
          />

          {/* Show Phone Input if NOT Admin */}
          {!isAdmin && (
            <InputField
              label="Phone Number"
              name="phone"
              value={editFormData.phone}
              onChange={(e) =>
                setEditFormData({ ...editFormData, phone: e.target.value })
              }
              placeholder="Enter phone number..."
            />
          )}

          <div className="mt-4 flex flex-col-reverse justify-end gap-2 sm:flex-row sm:gap-3">
            <CustomButton
              label="Cancel"
              variant="outline"
              color="#6B7280"
              borderColor="#D1D5DB"
              onClick={() => setIsEditModalOpen(false)}
            />
            <CustomButton
              label="Save Changes"
              type="submit"
              variant="solid"
              color="#02a9e0"
            />
          </div>
        </form>
      </Modal>

      {/* ==================================================================== */}
      {/* 2. CHANGE PASSWORD MODAL */}
      {/* ==================================================================== */}
      <Modal
        open={isPasswordModalOpen}
        title="Change Password"
        onClose={() => setIsPasswordModalOpen(false)}
      >
        <form onSubmit={handleChangePassword} className="flex flex-col gap-4 py-2">
          <InputField
            label="New Password"
            name="newPassword"
            type="password"
            value={passwordFormData.newPassword}
            onChange={(e) =>
              setPasswordFormData({
                ...passwordFormData,
                newPassword: e.target.value,
              })
            }
            placeholder="Enter new password..."
            required
          />

          <InputField
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            value={passwordFormData.confirmPassword}
            onChange={(e) =>
              setPasswordFormData({
                ...passwordFormData,
                confirmPassword: e.target.value,
              })
            }
            placeholder="Re-enter new password..."
            required
          />

          <div className="mt-4 flex flex-col-reverse justify-end gap-2 sm:flex-row sm:gap-3">
            <CustomButton
              label="Cancel"
              variant="outline"
              color="#6B7280"
              borderColor="#D1D5DB"
              onClick={() => setIsPasswordModalOpen(false)}
            />
            <CustomButton
              label="Update Password"
              type="submit"
              variant="solid"
              color="#02a9e0"
  
            />
          </div>
        </form>
      </Modal>
    </div>
  );
}